// extracted by mini-css-extract-plugin
export default {"buttonAlignCenter":"SnapCreate__buttonAlignCenter-aeZ5Z"};